import {
	email,
	name,
	phone,
	randNumRange,
} from '../../../../../../utils/generics';
import dateRange from '../../../../../../utils/dateRange';
import genericAddresses from '../../../../../../config/local/generic-addresses';

export default function getGenericValuationsData() {
	const length = 7;
	const randDate = dateRange(length);

	return [...Array(length).keys()].map((id) => {
		const randNum = randNumRange(0, length - 1);

		const address = {
			city: genericAddresses[randNum].city,
			country: 'US',
			postalCode: `${genericAddresses[randNum].postalCode}`,
			state: genericAddresses[randNum].state,
			streetAddress1: genericAddresses[randNum].streetAddress,
			streetAddress2: null,
		};

		return {
			address,
			contact: {
				email: email(),
				hasGroupSubscription: Math.random() > 0.5,
				id: `${id}`,
				leadScore: Math.floor(Math.random() * 100),
				leadScores: [
					{
						date: new Date(),
						score: Math.floor(Math.random() * 100),
					},
					{
						date: new Date('01/01/2024'),
						score: Math.floor(Math.random() * 100),
					},
				],
				name: name(),
				phone: phone(),
			},
			createdAt: randDate[id],
			value: randNumRange(250000 * 100, 650000 * 100),
		};
	});
}
